import loadable from '@loadable/component'

export default {
	base: loadable(() => import('/views/layouts/base')),
	content: loadable(() => import('/views/layouts/content')),
	raw: loadable(() => import('/views/layouts/raw')),
}